import React from 'react'
import { Controller } from 'react-hook-form'
import type { Control, UseControllerProps } from 'react-hook-form'
import InputNumber from 'antd/lib/input-number'
import { Stack, TextColors, Typography } from '@sureco/design-system'

type Props = {
  name: string
  control: Control<any, object>
  rules?: UseControllerProps['rules']
  label?: string
  required?: boolean
  disabled?: boolean
  min?: number
  placeholder?: string
}

const NOT_APPLICABLE = -1

const formatter = (value: number | string | undefined): string => {
  if (value === undefined || value === '' || value === null) return ''
  const n = typeof value === 'string' ? Number(value) : value
  if (isNaN(n) || n === NOT_APPLICABLE) return String(value)
  return '$' + n.toLocaleString('en-US')
}

const parser = (value: string | undefined): number | string => {
  if (!value) return ''
  const stripped = value.replace(/[$,\s]/g, '')
  if (stripped === '' || stripped === '-') return stripped
  const n = Number(stripped)
  return isNaN(n) ? stripped : n
}

export default function RHFCurrencyInput({
  name,
  control,
  rules,
  label,
  required,
  disabled,
  min,
  placeholder,
}: Props) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <Stack space={2}>
          {label && (
            <Typography>
              {label}
              {required && <span className="requiredMark">*</span>}
            </Typography>
          )}
          <InputNumber
            aria-label={label}
            style={{ width: '100%' }}
            value={field.value}
            onChange={(val) => field.onChange(val)}
            onBlur={field.onBlur}
            ref={field.ref}
            disabled={disabled}
            min={min}
            placeholder={placeholder}
            formatter={formatter}
            parser={parser as any}
            status={fieldState.error ? 'error' : undefined}
            controls={false}
          />
          {fieldState.error && (
            <Typography color={TextColors.error}>
              {fieldState.error.message}
            </Typography>
          )}
        </Stack>
      )}
    />
  )
}
